import { LIST_CANDIDATE_PARTY } from "../../constant";
import { GraphBox, GraphTitle, WrapGraphs } from "../style/styled";
const padding = 5;
const width =
  window.innerWidth < 500 ? window.innerWidth / 3 - padding * 2 - 40 : 100;
const canvasWidth = width + padding * 6;
const startHeight = 10;
const rectHeight = 15;
const totalHeight = 5;
const circleRadius = 4;
const COLOR = { BOSU: "#FF0000", JINBO: "#0077C1" };

const scaleWidth = (value) => value * width;

const getX = (start, bar) =>
  bar.dirNum === 1 ? start : start - scaleWidth(bar.percent);

const getCircleX = (start, bar) =>
  bar.dirNum === 1
    ? start + scaleWidth(bar.percent) - circleRadius / 2
    : start - scaleWidth(bar.percent) + circleRadius / 2;

const getNewX = (start, beforeBar) =>
  beforeBar.dirNum === 1
    ? start + scaleWidth(beforeBar.percent)
    : start - scaleWidth(beforeBar.percent);

const getShapePolygon = (dirNum, startX, barWidth, startY) => {
  const graphTrianglePointX = startX + barWidth;
  const getBarCenter = rectHeight / 2;
  const getCircleCenter = circleRadius / 2;
  const getTrianglePointTop = startY + getBarCenter - getCircleCenter;
  const getTrianglePointBottom = startY + getBarCenter + getCircleCenter;

  return dirNum === 1
    ? // 오른쪽 방향 그래프
      `${startX},${startY} 
    ${graphTrianglePointX},${getTrianglePointTop} 
    ${graphTrianglePointX},${getTrianglePointBottom} 
    ${startX},${startY + rectHeight}`
    : // 왼쪽 방향 그래프
      `${graphTrianglePointX},${startY} 
      ${startX},${getTrianglePointTop}
      ${startX},${getTrianglePointBottom}
      ${graphTrianglePointX},${startY + rectHeight} `;
};

const getAllBarLength = (first, second, third) =>
  scaleWidth(first.percent) * first.dirNum +
  scaleWidth(second.percent) * second.dirNum +
  scaleWidth(third.percent) * third.dirNum;

const getColor = (dirNum) =>
  dirNum === 1 ? "url(#GradientBosu)" : "url(#GradientJinbo)";

const getCircleColor = (dirNum) => (dirNum === 1 ? COLOR.BOSU : COLOR.JINBO);

export function CompVoteDirGraph({ data }) {
  return (
    <WrapGraphs>
      {data.map(
        ({
          first,
          second,
          third,
          sido,
          sgg,
          winner_17,
          winner_18,
          winner_19,
        }) => {
          const center = width / 2 + padding * 2;
          const isDir = first.dirNum + second.dirNum + third.dirNum;
          const allBarLength = getAllBarLength(first, second, third);

          const sumDirIsThree =
            width -
            scaleWidth(first.percent) -
            scaleWidth(second.percent) -
            scaleWidth(third.percent);

          const sumDirIsPlusOne =
            allBarLength < center ? center : width - allBarLength + padding * 2;
          const sumDirIsMinusOne =
            allBarLength < center ? center : width + allBarLength + padding * 2;

          const start =
            isDir === 3
              ? sumDirIsThree
              : isDir === 1
              ? sumDirIsPlusOne
              : sumDirIsMinusOne;
          return (
            <GraphBox key={`${sido}-${sgg}`}>
              <GraphTitle>{sido}</GraphTitle>
              <GraphTitle>{sgg}</GraphTitle>
              <svg width={canvasWidth} height="80">
                <defs>
                  <linearGradient id="GradientBosu">
                    <stop offset="0%" stopColor="#ffb1b1" />
                    <stop offset="100%" stopColor="#FF0000" />
                  </linearGradient>
                  <linearGradient id="GradientJinbo">
                    <stop offset="0%" stopColor="#0077C1" />
                    <stop offset="100%" stopColor="#afccdd" />
                  </linearGradient>
                </defs>

                {/* <rect
                x={getX(start, first)}
                y={startHeight}
                width={scaleWidth(first.percent)}
                height={rectHeight}
                fill={getColor(first.dirNum)}
              />
              getShapePolygon = (dirNum, startX, barWidth, startY)  
              */}
                <polygon
                  points={getShapePolygon(
                    first.dirNum,
                    getX(start, first),
                    scaleWidth(first.percent),
                    startHeight
                  )}
                  fill={getColor(first.dirNum)}
                />
                <line
                  x1={start}
                  y1={0}
                  x2={start}
                  y2={startHeight + rectHeight}
                  stroke="black"
                />
                <circle
                  cx={getCircleX(start, first)}
                  cy={startHeight + rectHeight * 0.5}
                  r={4}
                  fill={getCircleColor(LIST_CANDIDATE_PARTY[winner_17])}
                  stroke="#fff"
                />
                <polygon
                  points={getShapePolygon(
                    second.dirNum,
                    getX(getNewX(start, first), second),
                    scaleWidth(second.percent),
                    startHeight + totalHeight + rectHeight
                  )}
                  fill={getColor(second.dirNum)}
                />

                {/* <rect
                x={getX(getNewX(start, first), second)}
                y={startHeight + totalHeight + rectHeight}
                width={scaleWidth(second.percent)}
                height={rectHeight}
                fill={getColor(second.dirNum)}
              /> */}
                <circle
                  cx={getCircleX(getNewX(start, first), second)}
                  cy={startHeight + totalHeight + rectHeight * 1.5}
                  r={4}
                  fill={getCircleColor(LIST_CANDIDATE_PARTY[winner_18])}
                  stroke="#fff"
                />
                <line
                  x1={
                    first.dirNum === 1
                      ? getX(start, first) + scaleWidth(first.percent)
                      : getX(start, first)
                  }
                  y1={startHeight + rectHeight - circleRadius}
                  x2={
                    first.dirNum === 1
                      ? getX(start, first) + scaleWidth(first.percent)
                      : getX(start, first)
                  }
                  y2={startHeight + totalHeight + rectHeight * 2}
                  stroke="black"
                />

                {/* <rect
                x={getX(getNewX(getNewX(start, first), second), third)}
                y={startHeight + totalHeight * 2 + rectHeight * 2}
                width={scaleWidth(third.percent)}
                height={rectHeight}
                fill={getColor(third.dirNum)}
              /> */}
                <polygon
                  points={getShapePolygon(
                    third.dirNum,
                    getX(getNewX(getNewX(start, first), second), third),
                    scaleWidth(third.percent),
                    startHeight + totalHeight * 2 + rectHeight * 2
                  )}
                  fill={getColor(third.dirNum)}
                />
                <circle
                  cx={getCircleX(getNewX(getNewX(start, first), second), third)}
                  cy={startHeight + totalHeight * 2 + rectHeight * 2.5}
                  r={4}
                  fill={getCircleColor(LIST_CANDIDATE_PARTY[winner_19])}
                  stroke="#fff"
                />
                <line
                  x1={
                    second.dirNum === 1
                      ? getX(getNewX(start, first), second) +
                        scaleWidth(second.percent)
                      : getX(getNewX(start, first), second)
                  }
                  y1={startHeight + totalHeight + rectHeight * 2 - circleRadius}
                  x2={
                    second.dirNum === 1
                      ? getX(getNewX(start, first), second) +
                        scaleWidth(second.percent)
                      : getX(getNewX(start, first), second)
                  }
                  y2={startHeight + totalHeight * 2 + rectHeight * 3}
                  stroke="black"
                />
              </svg>
            </GraphBox>
          );
        }
      )}
    </WrapGraphs>
  );
}
